<template>
  <div v-if="stats" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Card 1: Total Egresos -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Egresos</span>
        <div class="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-lg">
          <i class="fa fa-coins" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-gray-900">{{ formatUSD(stats.total_outflows ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">Compras y gastos consolidados</p>
      </div>
    </div>

    <!-- Card 2: Compras de Mercancía -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Compras Mercancía</span>
        <div class="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-lg">
          <i class="fa fa-boxes-stacked" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-emerald-600">{{ formatUSD(stats.total_shoppings ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">{{ stats.count_shoppings ?? 0 }} compras con inventario</p>
      </div>
    </div>

    <!-- Card 3: Gastos Operativos -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Gastos Operativos</span>
        <div class="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center text-lg">
          <i class="fa fa-receipt" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-purple-600">{{ formatUSD(stats.total_spents ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">{{ stats.count_spents ?? 0 }} egresos directos</p>
      </div>
    </div>

    <!-- Card 4: Compras Pendientes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Compras Pendientes</span>
        <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-lg">
          <i class="fa fa-clock" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-amber-600">{{ stats.pending_shoppings ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Pendientes por pagar</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoppingStats',

  props: {
    stats: {
      type: Object,
      default: () => ({
        total_outflows: 0,
        total_shoppings: 0,
        count_shoppings: 0,
        total_spents: 0,
        count_spents: 0,
        pending_shoppings: 0,
      }),
    },
  },

  methods: {
    formatUSD(value) {
      const val = parseFloat(value) || 0
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(val)
    },
  },
}
</script>
